// @flow
import inboxService from './inboxService';
import inboxActionKeys from './inboxActionKeys';

const getInboxHtml = (
  serviceProviderId: string,
  conversationId: string,
  userId: string,
  isLeadPro: boolean,
  leadId: string,
  email: string,
): any => ({
  type: inboxActionKeys.GET_INBOX_PAGE,
  payload: {
    data: {
      serviceProviderId,
      conversationId,
      userId,
      isLeadPro,
      leadId,
      email,
    },
    promise: inboxService.getInboxHtml(
      serviceProviderId,
      conversationId,
      userId,
      isLeadPro,
      leadId,
      email,
    ),
  },
});

const getAutomationMessage = (serviceProviderId: string): any => ({
  type: inboxActionKeys.GET_AUTOMATION_MESSAGE,
  payload: {
    promise: inboxService.getAutomationMessage(serviceProviderId),
  },
});

const setAutomationMessage = (
  serviceProviderId: string,
  text: string,
): any => ({
  type: inboxActionKeys.SET_AUTOMATION_MESSAGE,
  payload: {
    data: { serviceProviderId, text },
    promise: inboxService.setAutomationMessage(serviceProviderId, text),
  },
});

const getAutomationTemplates = (serviceProviderId: string): any => ({
  type: inboxActionKeys.GET_AUTOMATION_TEMPLATES,
  payload: {
    promise: inboxService.getAutomationTemplates(serviceProviderId),
  },
});

const getUnreadMessageCount = (
  serviceProviderId: string,
  email: string,
  useNewApi?: boolean,
): any => ({
  type: inboxActionKeys.GET_UNREAD_MESSAGE_COUNT,
  payload: {
    data: {
      serviceProviderId,
      email,
    },
    promise: inboxService.getUnreadMessageCount(
      serviceProviderId,
      email,
      useNewApi,
    ),
  },
});

const setUnreadMessageCount = (unreadMessageCount: Number): any => ({
  type: inboxActionKeys.SET_UNREAD_MESSAGE_COUNT,
  payload: unreadMessageCount,
});

const setIsInboxEnabled = (isInboxEnabled: boolean): any => ({
  type: inboxActionKeys.SET_IS_INBOX_ENABLED,
  payload: isInboxEnabled,
});

const setIsAutomationEnabled = (isAutomationEnabled: boolean): any => ({
  type: inboxActionKeys.SET_IS_AUTOMATION_ENABLED,
  payload: isAutomationEnabled,
});

const setFetchUnreadCountFromConversationService = (useNewApi: boolean): any => ({
  type: inboxActionKeys.SET_FETCH_UNREAD_COUNT_FROM_CONVERSATION_SERVICE,
  payload: useNewApi,
});

const setShouldShowHeader = (shouldShowHeader: boolean): any => ({
  type: inboxActionKeys.SET_SHOULD_SHOW_HEADER,
  payload: shouldShowHeader,
});

export default {
  getAutomationMessage,
  getAutomationTemplates,
  getInboxHtml,
  getUnreadMessageCount,
  setAutomationMessage,
  setFetchUnreadCountFromConversationService,
  setIsAutomationEnabled,
  setIsInboxEnabled,
  setShouldShowHeader,
  setUnreadMessageCount,
};



// WEBPACK FOOTER //
// ./src/modules/inbox/common/inboxActions.js